<template>
  <keep-alive>
    <div class="pag-wrap exhibitor">
      <div class="bread-crumbs">
        <a
          href="//www.ciftis.org"
          clstag="appH5|keycount|exhibitorList|to-HomePage"
          >{{ $t('首页') }}</a
        ><i></i
        ><router-link
          tag="a"
          to="list"
          clstag="appH5|keycount|exhibitorList|to-exhibitorList"
          >{{ $t('展商名录') }}</router-link
        ><i></i><span>{{ $t('搜索结果') }}</span>
      </div>
      <div class="detail-box">
        <div class="search-box">
          <span
            ><input
              ref="searchInput"
              type="text"
              v-model="searchValue"
              :placeholder="$t('请输入企业名称')"
              @keyup.enter="toSearch"
              clstag="appH5|keycount|exhibitorList|input-search"
            /><a
              href="#"
              @click.prevent="toSearch"
              clstag="appH5|keycount|exhibitorList|btn-search"
              >{{ $t('搜索') }}</a
            >
            <div
              class="divInput"
              @mouseover="yearOptsVisible = true"
              @mouseout="yearOptsVisible = false"
            >
              <p>
                <span class="that-year">{{
                  years.filter(val => val.value === searchYear)[0].label
                }}</span>
                <i class="el-icon-caret-bottom"></i>
              </p>
              <div class="list" v-show="yearOptsVisible">
                <ul>
                  <li
                    @click="changeYear(item)"
                    v-for="item in years"
                    :key="item.value"
                  >
                    {{ item.label }}
                  </li>
                </ul>
              </div>
            </div>
          </span>
        </div>
        <div class="search-result">
          <p v-if="isSearched && totalRecords > 0">
            {{ $t('共') }}{{ totalRecords }}{{ $t('条相关搜索结果') }}
          </p>
          <p v-if="isSearched && totalRecords <= 0">
            {{ $t('未找到企业数据') }}
          </p>
          <van-loading v-if="isLoading" />
          <div class="list-box has-cate">
            <ol>
              <li
                v-for="(exhibitor, index) in exhibitorList"
                :key="exhibitor.enterpriseId"
              >
                <i>{{ index + 1 }}</i
                ><a
                  href="#"
                  @click.prevent="toDetail(exhibitor.enterpriseId)"
                  :clstag="
                    'appH5|keycount|exhibitorList|exhibitor-' +
                      exhibitor.accountDisplay
                  "
                  >{{
                    locale == 'en-US'
                      ? exhibitor.enterpriseEnglishName ||
                        exhibitor.enterpriseName
                      : exhibitor.enterpriseName
                  }}</a
                ><span v-if="industryClassObj[exhibitor.category]">{{
                  locale == 'en-US'
                    ? industryClassObj[exhibitor.category].enName
                    : industryClassObj[exhibitor.category].name
                }}</span>
              </li>
            </ol>
          </div>
          <div
            class="page-navi"
            clstag="appH5|keycount|exhibitorList|page-navi"
            v-if="isSearched"
          >
            <el-pagination
              background
              @current-change="handleCurrentChange"
              @current-page="currentPage"
              layout="total,prev,pager,next,jumper"
              :page-size="15"
              :total="totalRecords"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </keep-alive>
</template>

<script>
import { getIndustryClassTree, getExhibitorList } from '@/api/exhibition'
import { getLang } from '@/utils'
import getTranslation from '@/locale/getTranslation'

export default {
  data() {
    return {
      isSearched: false,
      isLoading: false,
      searchValue: '',
      exhibitorList: [],
      industryClass: [],
      industryClassObj: {},
      locale: getLang() || 'zh-CN',
      currentPage: 1,
      pageSize: 15,
      totalRecords: 0,
      totalPages: 0,
      yearOptsVisible: false,
      searchYear: '2023',
      years: [
        { label: getTranslation('2023年企业'), value: '2023' },
        { label: getTranslation('2022年企业'), value: '2022' },
        { label: getTranslation('2021年企业'), value: '2021' },
        { label: getTranslation('2020年企业'), value: '2020' },
        { label: getTranslation('全部企业'), value: '' }
      ]
    }
  },
  created() {
    this.searchValue = this.$route.query.searchValue
    this.searchYear = this.$route.query.year
  },
  async mounted() {
    this.$refs.searchInput.focus()
    await this.getIndustryClassAction()
    this.toSearch()
  },
  watch: {
    industryClass() {
      this.industryClass.forEach(industry => {
        this.industryClassObj[industry.categoryId] = {}
        this.industryClassObj[industry.categoryId].name = industry.categoryName
        this.industryClassObj[industry.categoryId].enName = industry.categoryEnglishName
      })
    }
  },
  methods: {
    errorHandle() {
      this.$message({
        type: 'error',
        message: getTranslation('请求失败，请稍后重试~')
      })
    },
    async getIndustryClassAction() {
      try {
        let _data = await getIndustryClassTree()
        if (_data) {
          this.industryClass = _data.data
          this.currClass =
            (this.industryClass[0] && this.industryClass[0].key) || ''
        }
      } catch (_err) {
        this.errorHandle(_err)
      }
    },

    async getExhibitorList() {
      this.isLoading = true
      try {
        const obj = {
          enterpriseName: this.searchValue,
          pageSize: this.pageSize,
          pageNumber: this.currentPage,
          year: this.searchYear === '' ? undefined : this.searchYear
        }
        // if (this.searchYear === '2021') {
        //   obj.notYear = 2020
        // } else if (this.searchYear === '2020') {
        //   obj.year = 2020
        // }
        let _data = await getExhibitorList(obj)
        this.isSearched = true
        this.isLoading = false
        if (_data.data) {
          this.exhibitorList = _data.data.records
          this.totalRecords = _data.data.total
          this.totalPages = _data.data.pages
        }
      } catch (_err) {
        this.isSearched = true
        this.isLoading = false
        this.errorHandle(_err)
      }
    },
    toSearch() {
      if (!this.searchValue) {
        this.$message({
          message: getTranslation('请输入搜索内容'),
          type: 'warning'
        })
        return
      }
      this.currentPage = 1
      this.getExhibitorList()
    },
    toDetail(_id) {
      this.$router.push({ path: 'detail', query: { enterpriseId: _id } })
    },
    toPage(_page) {
      this.currentPage = _page
      this.getExhibitorList()
    },
    changeYear(item) {
      this.searchYear = item.value
      this.yearOptsVisible = false
      this.currentPage = 1
      this.exhibitorList = []
      this.getExhibitorList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getExhibitorList()
    }
  }
}
</script>

<style lang="scss" scoped>
.divInput {
  display: inline-block;
  width: 230px;
  height: 40px;
  // border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fff;
  color: #333;
  font-size: 14px;
  margin-right: 20px;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
  text-align: center;
  margin-left: 20px;
}
.divInput > p {
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
  background-image: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#ffc002),
    to(#fe8c01)
  );
  background-image: gradient(
    linear,
    left top,
    right top,
    from(#ffc002),
    to(#fe8c01)
  );
  color: #fff;
}
.list {
  position: absolute;
  left: 0;
  top: 40px;
  width: 100%;
  background: #ffffff;
  border: 1px solid #e8eaeb;
  // box-shadow: 0px 2px 20px 0px rgba(0 0 0 8%);
  border-radius: 4px;
}
.list ul li {
  width: 100%;
  cursor: pointer;
  padding-left: 10px;
  height: 40px;
  font-size: 14px;
  color: #424754;
  text-align: center;
  font-weight: 400;
  line-height: 40px;
  background: #fff;
}
.list ul li:hover {
  background: rgba(255, 163, 1, 0.15);
  color: #fe8c01;
  cursor: pointer;
}
v-deep .el-pagination {
  text-align: right;
  font-size: 14px;
}
v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: linear-gradient(90deg, #ffc002, #fe8c01);
  color: #fff;
}
v-deep .el-pager li,
v-deep .el-pagination button {
  width: 40px;
  height: 40px;
  line-height: 40px;
}
v-deep.el-pagination span,
v-deep .el-pagination__editor.el-input .el-input__inner {
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
}
v-deep.el-pagination.is-background
  .el-pager
  li:not(.disabled):not(.active):hover {
  color: #fe8c01;
}
v-deep .el-pagination button,
v-deep .el-pagination span {
  font-size: 14px;
}
</style>
